import { useCallback, useMemo } from 'react';

export function useApi(token) {
  const baseUrl = '/api';

  const request = useCallback(
    async (path, options = {}) => {
      const res = await fetch(`${baseUrl}${path}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...options.headers,
        },
      });

      if (res.status === 401 || res.status === 403) {
        localStorage.removeItem('token');
        window.location.reload();
        return;
      }

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro na requisição');
      return data;
    },
    [token]
  );

  return useMemo(
    () => ({
      getProjects: () => request('/projects'),
      getProjectsUpdateStatus: () => request('/projects/update-status'),
      getProjectUpdateStatus: (id) => request(`/projects/update-status?projectId=${encodeURIComponent(id)}`),
      getProject: (id) => request(`/projects/${id}`),
      getProjectCommits: (id, limit = 20) =>
        request(`/projects/${id}/commits?limit=${limit}`),
      createProject: (data) => request('/projects', { method: 'POST', body: JSON.stringify(data) }),
      updateProject: (id, data) => request(`/projects/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
      deleteProject: (id) => request(`/projects/${id}`, { method: 'DELETE' }),
      triggerDeploy: (id, senha) => request(`/deploy/${id}`, { method: 'POST', body: JSON.stringify(senha ?{ password: senha } : {}) }),
      triggerSystemUpdate: () => request('/deploy/system/update', { method: 'POST' }),
      getDeployStatus: (id) => request(`/deploy/${id}/status`),
      getDeployLogs: (id) => request(`/deploy/${id}/logs`),
      getDeployHistory: (id) => request(`/deploy/${id}/history`),
      // Logs persistentes em arquivo
      getProjectLogs: (projectId, limit = 30) =>
        request(`/logs/${projectId}?limit=${limit}`),
      getDeployLogDetail: (projectId, logId) =>
        request(`/logs/${projectId}/${logId}`),
      getAllLastLogs: () => request('/logs'),
      getBackupsStatus: ({ atualizar = false } = {}) =>
        request(`/backups${atualizar ? '?atualizar=1' : ''}`),
      // Recursos do IIS (AppPools e Sites) para preenchimento assistido no formulário
      getIisResources: () => request('/iis/resources'),
    }),
    [request]
  );
}
